import http from 'Services/HttpService';
import { baseUrl as apiUrl, token as localStorageToken } from 'Utils/envLoader';
import getUser from 'Utils/userAuth';

const apiEndPoint = `${apiUrl}/auth`;

export const savingAuth = (token) => {
    localStorage.setItem(localStorageToken, token);
    return getUser(token);
};

export const postLogin = async (credentials) => {
    try {
        const loginResonse = await http.post(
            `${apiEndPoint}/login`,
            credentials,
            //, { withCredentials: true }
        );
        const {
            data: { token },
            status,
        } = loginResonse;
        // console.log(loginResonse);
        // console.log('headers', loginResonse.headers['set-cookie']);
        if (status !== 200) throw new Error();
        return savingAuth(token);
    } catch (ex) {
        throw ex;
    }
};

export const logout = () => {
    localStorage.removeItem(process.env.REACT_APP_DEV_MODE_KEY);
    localStorage.removeItem(localStorageToken);
};

export const verifyActivationToken = (token) => {
    return http.get(`${apiEndPoint}/verify/activation/${token}`);
};

export const activationToken = (token, data, init) => {
    const initData = init ? '?init=1' : '';
    return http.post(`${apiEndPoint}/verify/activation/${token}${initData}`, data);
};

export const resetPasswordRequest = (data) => {
    return http.post(`${apiEndPoint}/reset/password`, data);
};

export const vrifyResetToken = (token) => {
    return http.get(`${apiEndPoint}/verify/reset/${token}`);
};

export const changeResetPassword = (token, data) => {
    return http.post(`${apiEndPoint}/verify/reset/${token}`, data);
};

export const getDirectAuth = async (id) => {
    try {
        const loginResonse = await http.get(`${apiEndPoint}/direct/${id}`);
        const {
            data: { token },
            status,
        } = loginResonse;
        if (status !== 200) throw new Error();
        return token;
    } catch (ex) {
        let errMsg;
        if (ex.response && ex.response.data && ex.response.data.message) {
            errMsg = ex.response.data.message;
        } else {
            errMsg = "Une erreur s'est produite !";
        }
        throw new Error(errMsg);
    }
};
